import { render } from "./CustomCheck.vue?vue&type=template&id=09e08a78"
import script from "./CustomCheck.vue?vue&type=script&lang=js"
export * from "./CustomCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__